<!--
Author: TangChen
Date: 2018-10-10
Desc: 设置导航提示信息，为公共组件
 -->
<template>
    <div class="comp-nav-tips comp" :class="data.cla">
        <div class="bg-tit-text">
            <span>{{ data.tit }}</span>
            <p>{{ data.text }}</p>
        </div>
    </div>
</template>
<script>
export default {
    name: "Navtips",
    props: {
        data: {
            type: Object,
            default: function () {
                return {
                    tit: "",
                    text: ""
                };
            }
        }
    },
    data() {
        return {};
    },
    methods: {}
};
</script>
<style lang="scss">
@import "../../assets/css/varibles";
.comp-nav-tips {
    height: 164px;
    background: $bg14;
    position: relative;
    margin-bottom: 20px;
    &:after {
        content: "";
        display: block;
        position: absolute;
        height: 167px;
        width: 321px;
        background: url($computer) no-repeat;
        top: 21px;
        right: 34px;
    }
    &.bank:after {
        width: 353px;
        background: url($bankCard) no-repeat;
        right: 2px;
    }
    &.login-pwd:after {
        width: 304px;
        height: 172px;
        background: url($loginPwd) no-repeat;
    }
    &.trade-pwd:after {
        width: 295px;
        height: 173px;
        background: url($tradePwd) no-repeat;
    }
    &.register:after {
        width: 324px;
        height: 173px;
        background: url($register) no-repeat;
    }
    .bg-tit-text {
        position: absolute;
        left: 25px;
        top: 50%;
        margin-top: -34px;
        span {
            line-height: 34px;
            font-size: $f20;
            color: $color-b;
        }
        p {
            color: $text-color1;
            line-height: 24px;
        }
    }
}
</style>
